export const DEFAULT_GRID_ROW_HEIGHT = 52;
export const GRID_CELL_FONT_SIZE = 14;
export const GRID_CELL_LINE_HEIGHT = 1.4;
export const GRID_CELL_PADDING = DEFAULT_GRID_ROW_HEIGHT - GRID_CELL_FONT_SIZE - 1;
